// extracted by mini-css-extract-plugin
export default {"ProcessLists":"ProcessLists_ProcessLists__iwr-w","Process_frame":"ProcessLists_Process_frame__fS6A5"};